module.exports = "/_next/static/images/a62c1bc1439d25995d7f17b557444c3f-NU_ComplianceTeam_ParkerLogo-08 1_lg.png";